import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "d-flex justify-content-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Votre logo (500x500)", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "h5" }, "Enregistrer les informations de la pharmacie.", -1)
const _hoisted_6 = { class: "form-row" }
const _hoisted_7 = {
  class: "form-group col-md-4",
  hidden: ""
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "mylogo" }, "Select Photo:", -1)
const _hoisted_9 = { class: "form-group col-md-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "Nom:", -1)
const _hoisted_11 = { class: "form-group col-md-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "Adresse:", -1)
const _hoisted_13 = { class: "form-group col-md-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Boite Postale:", -1)
const _hoisted_15 = { class: "form-group col-md-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Capital:", -1)
const _hoisted_17 = { class: "form-group col-md-4" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", null, "Statut juridique:", -1)
const _hoisted_19 = { class: "form-group col-md-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "RCCM:", -1)
const _hoisted_21 = { class: "form-group col-md-4" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "NIF:", -1)
const _hoisted_23 = { class: "form-group col-md-4" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Tel 1:", -1)
const _hoisted_25 = { class: "form-group col-md-4" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Tel 2:", -1)
const _hoisted_27 = { class: "form-group col-md-4" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", null, "Email:", -1)
const _hoisted_29 = { class: "form-group col-md-4" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Site web:", -1)
const _hoisted_31 = { class: "form-group col-md-4" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Devise:", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("option", { value: "FCFA" }, "FCFA", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("option", { value: "USD" }, "Dollar Americain", -1)
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { for: "slogan" }, "Slogan", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("small", null, "Affichage sous les tickets de caisse", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", { class: "h5 my-3" }, "Enregistrer les informations de votre environnement.", -1)
const _hoisted_40 = { class: "form-row" }
const _hoisted_41 = { class: "form-group col-md-4" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", null, "TVA:", -1)
const _hoisted_43 = { class: "form-group col-md-4" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", null, "CSS:", -1)
const _hoisted_45 = {
  type: "submit",
  class: "btn btn-bleu2 text-right"
}
const _hoisted_46 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock("div", {
        key: _ctx.photokey,
        class: "col-md-3 text-center",
        style: {"background-color":"antiquewhite","cursor":"pointer"}
      }, [
        (_ctx.$store.getters.pharmacie && (_ctx.$store.getters.pharmacie.logo_url || _ctx.$store.getters.pharmacie.logo))
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.$store.getters.pharmacie.logo_url || _ctx.$store.getters.pharmacie.logo,
              alt: "logo",
              id: "logo",
              class: "rounded mb-3 border",
              style: {"width":"200px","height":"200px"}
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true),
        _hoisted_4,
        _createElementVNode("input", {
          id: "mylogo",
          name: "mylogo",
          type: "file",
          class: "form-control",
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args))),
          accept: "image/*"
        }, null, 32)
      ]))
    ]),
    _createElementVNode("form", {
      onSubmit: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveCompanyInfo && _ctx.saveCompanyInfo(...args)), ["prevent"]))
    }, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("input", {
            id: "mylogo",
            name: "mylogo",
            type: "file",
            class: "form-control",
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args))),
            accept: "image/*"
          }, null, 32)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.nom_pharmacie) = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.formData.nom_pharmacie]
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.adresse) = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.formData.adresse]
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.bp) = $event))
          }, null, 512), [
            [_vModelText, _ctx.formData.bp]
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _withDirectives(_createElementVNode("input", {
            type: "number",
            class: "form-control",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.capital) = $event))
          }, null, 512), [
            [
              _vModelText,
              _ctx.formData.capital,
              void 0,
              { number: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.statut_juridique) = $event))
          }, null, 512), [
            [_vModelText, _ctx.formData.statut_juridique]
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.rccm) = $event))
          }, null, 512), [
            [_vModelText, _ctx.formData.rccm]
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.nif) = $event))
          }, null, 512), [
            [_vModelText, _ctx.formData.nif]
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _withDirectives(_createElementVNode("input", {
            type: "tel",
            class: "form-control",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.telephone1) = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.formData.telephone1]
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _withDirectives(_createElementVNode("input", {
            type: "tel",
            class: "form-control",
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.telephone2) = $event))
          }, null, 512), [
            [_vModelText, _ctx.formData.telephone2]
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _withDirectives(_createElementVNode("input", {
            type: "email",
            class: "form-control",
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.email) = $event))
          }, null, 512), [
            [_vModelText, _ctx.formData.email]
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.site_web) = $event))
          }, null, 512), [
            [_vModelText, _ctx.formData.site_web]
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("select", {
              class: "form-control",
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.devise) = $event))
            }, _hoisted_35, 512), [
              [_vModelSelect, _ctx.formData.devise]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_36, [
        _hoisted_37,
        _withDirectives(_createElementVNode("input", {
          id: "slogan",
          type: "text",
          class: "form-control",
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.slogan) = $event))
        }, null, 512), [
          [_vModelText, _ctx.formData.slogan]
        ]),
        _hoisted_38
      ]),
      _hoisted_39,
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _hoisted_42,
          _withDirectives(_createElementVNode("input", {
            type: "number",
            step: "any",
            placeholder: "ex : 0.18",
            class: "form-control",
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.tva) = $event)),
            required: ""
          }, null, 512), [
            [
              _vModelText,
              _ctx.formData.tva,
              void 0,
              { number: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          _withDirectives(_createElementVNode("input", {
            type: "number",
            step: "any",
            placeholder: "ex : 0.10",
            class: "form-control",
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.css) = $event))
          }, null, 512), [
            [
              _vModelText,
              _ctx.formData.css,
              void 0,
              { number: true }
            ]
          ])
        ])
      ]),
      _createElementVNode("button", _hoisted_45, [
        _createTextVNode(" Enregistrer "),
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_46))
          : _createCommentVNode("", true)
      ])
    ], 32)
  ]))
}